<template>
    <Card :title="$t('labels.product_type')">
        <div class="card-body">
            <CategoryFieldsetGroup v-model:category="category" />
        </div>
        <div class="card-footer d-flex justify-content-end flex-wrap" :style="{ gap: '.5rem'}">
            <AppButton color="light" @click="remove">
                <i class="icon-trash mr-2"></i>
                {{ $t('buttons.delete') }}
            </AppButton>
            <AppButton color="indigo" @click="update">
                <i class="icon-floppy-disk mr-2"></i>
                {{ $t('buttons.edit') }}
            </AppButton>
        </div>
    </Card>
</template>
<script>
import Card from '../../../../components/new/CardComponent.vue';
import AppButton from '../../../../components/new/button/AppButton.vue';
import CategoryFieldsetGroup from './fieldsets/CategoryFieldsetGroup.vue';

import { httpClient } from '../../../../services/HttpClient';
import MessageNotificator from '../../../../services/MessageNotificator';

export default {
    name: 'EditCategoryPage',
    components: {
        Card, CategoryFieldsetGroup, AppButton
    },
    data() {
        return {
            category: {
                name: '',
                markup: 0
            }
        }
    },
    methods: {
        async fetchCategory() {
            await httpClient.get(`/projects/${this.$route.params.projectUuid}/pim/types/${this.$route.params.categoryUuid}`).then((response) => {
                this.category = response.data.data
            })
        },
        async update() {
            let request = {};

            if (this.category.name) {
                request.name = this.category.name
            }

            if (this.category.markup) {
                request.markup = this.category.markup
            }

            await httpClient.patch(`/projects/${this.$route.params.projectUuid}/pim/types/${this.$route.params.categoryUuid}`, request).then((response) => {
                new MessageNotificator().success(this.$t('alerts.success'))
            })
        },
        async remove() {
            new MessageNotificator().confirm(this.$t("alerts.confirm_delete", {
                value: this.$t("labels.category")
            }), async () => {
                await httpClient.delete(`/projects/${this.$route.params.projectUuid}/pim/types/${this.$route.params.categoryUuid}`).then((response) => {
                    this.$router.push({ name: 'InternalProductTypesIndexPage' })
                })
            })
        }
    },
    async mounted() {
        await this.fetchCategory()
    }
}
</script>
